module.exports = __webpack_public_path__ + "static/media/Tier_6.bfc25707.png";